import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);class SectionSurprise {
    constructor() {
        this.ScrollStart= "top+=100 bottom";
    }
    init(){
        let surpriseSubtitleWrapper=document.querySelector('.surprise__subtitle')
        let surpriseSubtitle=document.querySelector('.surprise__subtitle-image')
        let surpriseInfo=document.querySelector('.surprise__info')
        let surpriseInfoItems=document.querySelectorAll('.surprise__info li strong')
        window.addEventListener("resize", () => {
            let windowWidth=window.innerWidth;
            if(windowWidth<=992){
                this.ScrollStart="start bottom";
            }else{
                this.ScrollStart="top+=100 bottom";
            }
        });
        let surpriseSubtitleTl = gsap.timeline({
            scrollTrigger: {
                trigger: surpriseSubtitleWrapper,
                start: this.ScrollStart,
                end:"center center",
                //scrub: 1,
                //markers:true
            }
        });
        surpriseSubtitleTl.from(surpriseSubtitle, {duration: 0.4,xPercent: -100})
        let surpriseInfoTl = gsap.timeline({
            scrollTrigger: {
                trigger: surpriseInfo,
                start: this.ScrollStart,
                end:"center center",
                // scrub: 1,
            }
        });
        surpriseInfoTl.from(surpriseInfoItems, {duration: 0.5, top: 50,stagger: 0.1})
    } 
}
export default SectionSurprise